import { render, staticRenderFns } from "./profile-item.vue?vue&type=template&id=3a297fab&"
import script from "./profile-item.vue?vue&type=script&lang=ts&"
export * from "./profile-item.vue?vue&type=script&lang=ts&"
import style0 from "./profile-item.vue?vue&type=style&index=0&id=3a297fab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports